"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderLearningComponent = exports.LearningComponent = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var app_1 = require("app");
var webexUI_1 = require("webexUI");
var FilterableList_1 = require("Views/Partials/Components/FilterableList");
var helpers_1 = require("Views/Partials/Components/TableCore/helpers");
var TableCore_1 = require("Views/Partials/Components/TableCore/TableCore");
var typings_1 = require("Views/Partials/Components/TableCore/typings");
var helpers_2 = require("../helpers");
var LearningComponent = function (_a) {
    var dataService = _a.dataService, tableCaption = _a.tableCaption, dictionary = _a.dictionary, tileStatusExpanded = _a.tileStatusExpanded;
    var tableRef = React.useRef();
    var _b = React.useState({
        rows: null,
        status: null,
    }), _c = _b[0], rows = _c.rows, status = _c.status, setState = _b[1];
    var generateMessage = React.useCallback(function (statusCode) {
        switch (statusCode) {
            case FilterableList_1.ListStatusCode.zeroResults:
                return dictionary.zeroResultMessage;
            case FilterableList_1.ListStatusCode.communicationError:
                return dictionary.communicationErrorMessage;
            default:
                return;
        }
    }, [dictionary.communicationErrorMessage, dictionary.zeroResultMessage]);
    var updateStateWithData = React.useCallback(function (_a) {
        var coursesData = _a.coursesData, statusCode = _a.statusCode;
        setState({
            rows: helpers_2.transformDataToGeneralSchema(coursesData),
            status: {
                statusCode: statusCode,
                message: generateMessage(statusCode),
            },
        });
    }, [generateMessage]);
    app_1.useDidMount(function () {
        if (dataService) {
            dataService.getDataForLearningComponent().then(function (data) { return updateStateWithData(data); });
        }
    });
    var columnsTitles = React.useMemo(function () { return helpers_2.getTableHeaderData(rows !== null && rows !== void 0 ? rows : [], dictionary); }, [dictionary, rows]);
    var filterItems = React.useMemo(function () { return helpers_1.getUniqueItems({ columns: columnsTitles, rows: rows !== null && rows !== void 0 ? rows : [] }); }, [columnsTitles, rows]);
    var tableClassName = React.useMemo(function () { return "table learning-component " + ((rows === null || rows === void 0 ? void 0 : rows.length) === 0 ? 'learning-component-without-rows' : ''); }, [rows === null || rows === void 0 ? void 0 : rows.length]);
    if (!rows) {
        return (React.createElement("div", { className: "spinner-wrapper" },
            React.createElement(webexUI_1.Spinner, { className: "learning-component-spinner", visible: true })));
    }
    return (React.createElement("div", { className: "learning-table-wrap", ref: tableRef },
        React.createElement(TableCore_1.TableCore, { dictionary: dictionary, className: tableClassName, tableType: typings_1.TableTypeEnum.Learning, columns: columnsTitles, status: status, rows: rows, filterItems: filterItems, expandableWrapperClassName: ".learning-table-wrap", tableWrapperClassName: "learning-table-wrapper", tableCaption: tableCaption, tileStatusExpanded: tileStatusExpanded })));
};
exports.LearningComponent = LearningComponent;
function RenderLearningComponent(data, element) {
    app_1.reactDOMRender(React.createElement(exports.LearningComponent, tslib_1.__assign({}, data)), element);
}
exports.RenderLearningComponent = RenderLearningComponent;
